import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { env } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private http: HttpClient) { }

  updateAccount(data) {
    return this.http.put(env.server + '/user/' + data._id, data);
  }

  login(user, pass) {
    return this.http.post(env.server + '/auth/authenticate', {
      email: user,
      password: pass
    }
    );
  }

  isLoggedIn() {
    if (localStorage.getItem('user') === null) {
      return false;
    }
    var currentUser = localStorage.getItem('user');
    currentUser = JSON.parse(currentUser);
    if (currentUser) {
      return true;
    } else {
      return false;
    }
  }

  currentUser() {
    var currentUser = localStorage.getItem('user');
    currentUser = JSON.parse(currentUser);
    if (currentUser) {
      return currentUser;
    } else {
      return null;
    }
  }

  enableUser(data) {
    return this.http.post(env.server + '/user/disable/' + data._id, {
      disabled: data.disabled
    });
  }

  changePassword(data) {
    return this.http.post(env.server + '/user/change-password', {
      userId: data.userId,
      newPassword: data.newPassword
    })
  }

  getAllUsers() {
    return this.http.get(env.server + '/user/all');
  }

}
